import {appendAll} from "../utils/helpers";

const LAMMediaArticle = () => {
  const liquidData = JSON.parse(
    document.getElementById(`lam-media-article-metafields`).textContent
  );

  appendAll(liquidData);
}

export default LAMMediaArticle;